import { Component } from '@angular/core';
import { IntegrationsService } from '@services/integrations.service';
import { ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { UserService } from '@services/user.service';
import { CourseService } from '@scaffold/services/course.service';


@Component({
  selector: 'app-integration-select',
  templateUrl: './integration-select.component.html',
  styleUrls: ['./integration-select.component.scss']
})
export class IntegrationSelectComponent {

  roleData: any;
  selectedIntegration: any[] = [];
  filterText: string = '';
  filteredIntegrations: any[] = [];
  integrations: any[];
  course: any;
  loading: boolean = false;
  constructor(private integrationsService: IntegrationsService, private dialogRef: ScaffoldDialogRef,
    private userService: UserService, private courseService: CourseService
  ) { }

  ngOnInit(): void {
    this.userService.getRoleDetails().subscribe((data) => {
      this.roleData = data;
    });
    this.loading = true;
    this.courseService.getCurrentCourseDetails().subscribe((course) => {
      this.course = course;
      console.log(this.course)
    });
    this.integrationsService.getIntegrations().subscribe((integrations) => {
      console.log("integrations", integrations)
      if(!integrations || integrations.length === 0 || integrations.errorType) {
        this.loading = false;
        this.integrations = [];
        return;
      }
      this.integrations = integrations.filter((integration) => integration.data_direction !== 'source');
      this.integrations.forEach((integration) => {
        console.log(integration)
        integration.has_course = this.course?.data?.destination_lms?.includes(integration.name) || this.course?.data?.hasOwnProperty(integration.name + '_id');
        integration.is_source = this.course?.data?.source_lms === integration.name;
      });
      this.filteredIntegrations = this.integrations;
      this.loading = false;
      console.log(this.integrations)
    });
  }

  filterIntegrations() {
    this.filteredIntegrations = this.integrations.filter((integration) => {
      let filterName = integration.friendly_name || integration.name;
      return filterName?.toLowerCase().includes(this.filterText.toLowerCase());
    });
  }

  selectIntegration(integration: any) {
    this.selectedIntegration[0] = integration;
   /* if (this.selectedIntegration.includes(integration)) {
      this.selectedIntegration = this.selectedIntegration.filter((i) => i !== integration);
    } else {
      this.selectedIntegration.push(integration);
    }*/
  }

  select(syncNewCourse: boolean) {
    this.dialogRef.close({selectedIntegration: this.selectedIntegration, syncNewCourse});
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getNoIntegrationMessage() {
    if(this.roleData?.only_authorized_integrations) {
      return "not_authorized_to_view_any_integrations";
    }
    return "no_integrations_to_display";
  }
}
